import React from "react";
import { Typography, Container, Grid, Link, Divider, Box } from "@mui/material";
import { Email, Language } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#00171f",
        color: "#fff",
        padding: { xs: "32px 16px", md: "48px 24px" },
        marginTop: "80px",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
            >
              Halal World
            </Typography>
            <Typography
              variant="body2"
              style={{ fontFamily: "Poppins, sans-serif" }}
            >
              Providing accurate halal information for travelers worldwide.
            </Typography>
            <Typography
              variant="body2"
              sx={{ mt: 2, fontFamily: "Poppins, sans-serif" }}
            >
              Found incorrect information? Want to contribute? C
              <Link href="/contact" color="inherit" underline="none">
                ontact us
              </Link>
            </Typography>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
            >
              Navigation
            </Typography>
            <Box
              component="ul"
              sx={{ listStyle: "none", padding: 0, margin: 0 }}
            >
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Home
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/numbers"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  E-Numbers
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/restaurants/jp"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Restaurants
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/mosques/jp"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Mosques
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
            >
              Legal
            </Typography>
            <Box
              component="ul"
              sx={{ listStyle: "none", padding: 0, margin: 0 }}
            >
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Privacy Policy
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Terms
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link
                  href="/contact"
                  color="inherit"
                  underline="hover"
                  sx={{ fontFamily: "Poppins, sans-serif" }}
                >
                  Contact Us
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
            >
              Contact
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Email fontSize="small" sx={{ mr: 1 }} />
              <Link
                href="mailto:world.halal123@gmail.com"
                color="inherit"
                underline="hover"
                sx={{ fontFamily: "Poppins, sans-serif" }}
              >
                world.halal123@gmail.com
              </Link>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Language fontSize="small" sx={{ mr: 1 }} />
              <Typography
                variant="body2"
                sx={{ fontFamily: "Poppins, sans-serif" }}
              >
                Global Service
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            my: 4,
            borderBottomWidth: 1,
          }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontFamily: "Poppins, sans-serif" }}
          >
            © {new Date().getFullYear()} Halal World
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontFamily: "Poppins, sans-serif" }}
          >
            All rights reserved
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
